/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { Link } from "react-router-dom"
import { PixelButton } from "./PixelButton"

export function PrimaryButton({
  children,
  onClick,
  disabled,
  to,
  color = "primary",
  renderRight,
  renderLeft,
}: {
  children: any
  onClick?: any
  disabled?: boolean
  to?: string
  color?: string
  renderRight?: () => React.ReactNode
  renderLeft?: () => React.ReactNode
}) {
  const variant = color === "white" ? "white" : color === "red" ? "danger" : "primary"
  const button = (
    <PixelButton
      onClick={onClick}
      disabled={disabled}
      variant={variant}
    >
      {renderLeft && renderLeft()}
      {children}
      {renderRight && renderRight()}
    </PixelButton>
  )
  if (to) {
    return <Link to={to}>{button}</Link>
  } else {
    return button
  }
}

export function FormSubmitButton({ value }: { value?: string }) {
  return (
    <PixelButton type="submit" variant="primary" icon="save">
      {value || "Save"}
    </PixelButton>
  )
}
